// extracted by mini-css-extract-plugin
export default {"wrapper":"Onbording_wrapper__CsujJ","wrapperDiv":"Onbording_wrapperDiv__rjfn3","active":"Onbording_active__efqmP"};